import { useNavigate } from "react-router-dom";
import "./NewSitesStyle.css";
import { useEffect, useState } from "react";
import i18next from "i18next";

function convertToThumbnailUrl(url) {
  if (!url) return ""; // Handle empty or undefined URL

  const parts = url.split("/");
  const filename = parts.pop(); // Extract filename
  const [name, ext] = filename.split("."); // Split into name and extension

  if (!name || !ext) return url; // Return original URL if format is invalid

  return `${process.env.REACT_APP_IMAGE_PATH}/${parts.join(
    "/"
  )}/${name}_thumbnail.${ext}`;
}

const NewSites = ({ sites, locations, t }) => {
  const navigate = useNavigate();
  const [newLocations, setNewLocations] = useState([]);

  useEffect(() => {
    const data = [
      // Add locations to the options, grouped by their parent site name
      ...locations.map((location) => {
        const site = sites.find((s) => s.id === location.site_id); // Find the parent site
        return {
          location_name: location.location_name,
          description: location.description,
          image: location.image,
          siteLink: site?.link,
          subsiteLink: location.link,
          id: location.id,
        };
      }),
    ];
    setNewLocations(data.sort((a, b) => b.id - a.id).slice(0, 2));
  }, [sites, locations]);

  return (
    <div className="newSites-container">
      <div className="newSites-content">
        <h2>{t("new_sites")}</h2>
        <div className="sites-row">
          <div className="site-card">
            <div className="newSites-img-container">
              <img
                src={convertToThumbnailUrl(newLocations[0]?.image)}
                alt="new-location-1"
              />
              <span>{t("new")}</span>
            </div>
            <h4>{newLocations[0]?.location_name}</h4>
            <p>{newLocations[0]?.description}</p>
            <button
              className="btn"
              style={{ width: "100%" }}
              onClick={() =>
                navigate(
                  `/site/${newLocations[0]?.siteLink}/location/${newLocations[0]?.subsiteLink}/${i18next.language}`
                )
              }
            >
              {t("watch_now")}
            </button>
          </div>
          <hr />
          <div className="site-card">
            <div className="newSites-img-container">
              <img
                src={convertToThumbnailUrl(newLocations[1]?.image)}
                alt="new-location-2"
              ></img>
              <span>{t("new")}</span>
            </div>
            <h4>{newLocations[1]?.location_name}</h4>
            <p>{newLocations[1]?.description}</p>
            <button
              className="btn"
              style={{ width: "100%" }}
              onClick={() =>
                navigate(
                  `/site/${newLocations[1]?.siteLink}/location/${newLocations[1]?.subsiteLink}/${i18next.language}`
                )
              }
            >
              {t("watch_now")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSites;
